import salmos from "@/data/salmos.json";

export const LANGS = [
  { code: "pt", label: "PT", nome: "Português" },
  { code: "en", label: "EN", nome: "English" },
  { code: "es", label: "ES", nome: "Español" },
  { code: "fr", label: "FR", nome: "Français" },
];

export const getSalmos = () => salmos;

export const getSalmoByNumero = (numero) =>
  salmos.find((s) => s.numero === parseInt(numero, 10));

export const getSalmoDoDia = () => {
  const hoje = new Date();
  const inicio = new Date(hoje.getFullYear(), 0, 0);
  const diaDoAno = Math.floor((hoje - inicio) / 86400000);
  return salmos[diaDoAno % salmos.length];
};

export const getTitulo = (s, lang = "pt") => s?.titulos?.[lang] || s?.titulos?.pt || "";
export const getTexto = (s, lang = "pt") => s?.textos?.[lang] || s?.textos?.pt || "";
export const getReflexao = (s, lang = "pt") => s?.reflexoes?.[lang] || "";

export const pesquisarSalmos = (query, lang = "pt") => {
  if (!query) return [];
  const q = query.toLowerCase().trim();
  return salmos.filter((s) => {
    const titulo = (getTitulo(s, lang) || "").toLowerCase();
    const texto = (getTexto(s, lang) || "").toLowerCase();
    return (
      String(s.numero).includes(q) ||
      titulo.includes(q) ||
      texto.includes(q) ||
      (s.tags || []).some((t) => t.toLowerCase().includes(q)) ||
      (s.situacoes || []).some((sit) => sit.toLowerCase().includes(q))
    );
  });
};

export const getSalmosPorSituacoes = (situacoes) => {
  return salmos.filter(
    (s) =>
      (s.situacoes || []).some((sit) =>
        situacoes.some((alvo) => sit.toLowerCase().includes(alvo.toLowerCase()))
      )
  );
};

export const getSalmosRelacionados = (numero, limite = 3) => {
  const atual = getSalmoByNumero(numero);
  if (!atual) return [];
  const tagsAtual = atual.tags || [];
  const score = (s) => (s.tags || []).filter((t) => tagsAtual.includes(t)).length;
  return salmos
    .filter((s) => s.numero !== atual.numero && (s.destacado || score(s) > 0))
    .map((s) => ({ s, score: score(s) }))
    .sort((a, b) => b.score - a.score)
    .slice(0, limite)
    .map((x) => x.s);
};

export const primeirasPalavras = (texto, n = 20) => {
  if (!texto) return "";
  return texto.split(/\s+/).slice(0, n).join(" ") + "...";
};
